import styled from 'styled-components'
import * as C from '../util/Colors'

export const Menu = styled.div`
    font-size: 1rem;
    font-weight: bold;
    text-align:center;
    background-image: linear-gradient(${C.SECONDARY}, ${C.PRIMARY});
    width:20%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    color:${C.WHITE};
    font-weight: bold;
`;

export const styleDivisor = { 
    margin:`2px auto`, 
    borderColor:`white`,
    width:`85%`
}